/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v1beta1/filter.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiPredicate } from './ApiPredicate';
import {
  ApiPredicateFromJSON,
  ApiPredicateFromJSONTyped,
  ApiPredicateToJSON,
  ApiPredicateToJSONTyped,
} from './ApiPredicate';

/**
 * Filter is used to filter resources returned from a ListXXX request.
 *
 * Example filters:
 * 1) Filter runs with status = 'Running'
 * filter {
 *   predicate {
 *     key: "status"
 *     op: EQUALS
 *     string_value: "Running"
 *   }
 * }
 *
 * 2) Filter runs that succeeded since Dec 1, 2018
 * filter {
 *   predicate {
 *     key: "status"
 *     op: EQUALS
 *     string_value: "Succeeded"
 *   }
 *   predicate {
 *     key: "created_at"
 *     op: GREATER_THAN
 *     timestamp_value {
 *       seconds: 1543651200
 *     }
 *   }
 * }
 *
 * 3) Filter runs with one of labels 'label_1' or 'label_2'
 *
 * filter {
 *   predicate {
 *     key: "label"
 *     op: IN
 *     string_values {
 *       value: 'label_1'
 *       value: 'label_2'
 *     }
 *   }
 * }
 * @export
 * @interface ApiFilter
 */
export interface ApiFilter {
  /**
   * All predicates are AND-ed when this filter is applied.
   * @type {Array<ApiPredicate>}
   * @memberof ApiFilter
   */
  predicates?: Array<ApiPredicate>;
}

/**
 * Check if a given object implements the ApiFilter interface.
 */
export function instanceOfApiFilter(value: object): value is ApiFilter {
  return true;
}

export function ApiFilterFromJSON(json: any): ApiFilter {
  return ApiFilterFromJSONTyped(json, false);
}

export function ApiFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiFilter {
  if (json == null) {
    return json;
  }
  return {
    predicates:
      json['predicates'] == null
        ? undefined
        : (json['predicates'] as Array<any>).map(ApiPredicateFromJSON),
  };
}

export function ApiFilterToJSON(json: any): ApiFilter {
  return ApiFilterToJSONTyped(json, false);
}

export function ApiFilterToJSONTyped(
  value?: ApiFilter | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    predicates:
      value['predicates'] == null
        ? undefined
        : (value['predicates'] as Array<any>).map(ApiPredicateToJSON),
  };
}
